export const sheetConfig = {
    repeatedBar: '%',
    columns: 4
}

export const colorConfig = {
    saturationDefault: 40,
    saturationActive: 50,
    brightnessDefault: 80,
    brightnessActive: 60,
}


// WEBPACK FOOTER //
// ./src/config.js